import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//slices
import { Autocomplete, Box, Card, CardContent, Divider, TextField, Typography } from '@mui/material';
import SelectableThumbnails from '../../../ImageViewerModal/components/ImageInspector/SelectableThumbnails';
import { selectFrameARI } from '../../../../../../../store/slices/reportsSlice';
import Checkbox from '../../../../../../../components/Checkbox';


const Step3DescribeItem = forwardRef(({ report_id, roomCategories, itemData, setNotifState }, ref) => {
    const dispatch = useDispatch();

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isDamage, setIsDamage] = useState(false);

    useImperativeHandle(ref, () => ({ handleSubmit, }));

    const handleSubmit = async () => {
        if (title.trim() === '') {
            setNotifState({ type: 'error', text: 'Please provide a title for the item.' });
            return;
        }
        if (selectedCategory.trim() === '') {
            setNotifState({ type: 'error', text: 'Please provide a description for the item.' });
            return;
        }

        // 'report_id', 'title', 'description', 'room', 'category', 'isDamage', 'bbox', 'imgIndex' 
        const payload = {
            report_id,
            title,
            description,
            room: itemData.room,
            category: selectedCategory,
            isDamage,
            bbox: itemData.rect,
            imgIndex: itemData.imgIndex,
            frameNum: itemData.frameNum,
        };

        return payload;
    };

    return (
        <div className="p-6 bg-white">
            <h2 className="text-lg font-bold mb-2">Describe what you're reporting</h2>

            <p>
                You're almost done!
                Give this item a short <b>title</b>, mark if its a damage, and choose the <b>category</b> it belongs to within the room. 
                Additionally, you may add a <b>description</b> to provide more context about the issue.
                This information helps ensure the issue is properly documented and easy to understand for anyone reviewing the report.
            </p>

            <div className="mt-6 mb-6">
                <Divider className="my-8 mt-4" />
            </div>

            {/* Title */}
            <TextField
                label="Title"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Update title for this item"
                fullWidth
                variant="outlined"
                sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#E0E0E0', 
                        },
                        '&:hover fieldset': {
                            borderColor: '#BDBDBD', 
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#4F46E5', 
                        },
                    },
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                        padding: '10px 14px',
                    },
                    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                        fontSize: '14px',
                        marginTop: '-6px',
                    }
                }}
            />
            
            {/* Description Input */}
            <TextField
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Add a description for this item"
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                sx={{
                    my: 2,
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#E0E0E0', 
                        },
                        '&:hover fieldset': {
                            borderColor: '#BDBDBD', 
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#4F46E5', 
                        },
                    },
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                    },
                }}
            />

            <Autocomplete
                freeSolo
                options={roomCategories}
                inputValue={selectedCategory}
                onInputChange={(e, newInputValue) => setSelectedCategory(newInputValue)}
                renderInput={(params) => <TextField {...params} label="Category" />}
            />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: 2 }}>
                <Checkbox
                    checked={isDamage}
                    onChange={(e) => setIsDamage(e.target.checked)}
                    sx={{
                        height: '17px',
                        width: '17px',
                        padding: '0px',
                        "& .MuiSvgIcon-root": {
                            width: "17px",
                            height: "17px",
                        }
                    }}
                />
                <Typography sx={{ fontSize: '14px', color: '#0C1222', lineHeight: '130%'}}>Select if the item is a damage</Typography>
            </Box>
            
        </div>
    );
});

export default Step3DescribeItem;
